"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _debounce2 = _interopRequireDefault(require("lodash/debounce"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _memoize2 = _interopRequireDefault(require("lodash/memoize"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./autocomplete.scss");

var _compose = _interopRequireDefault(require("recompose/compose"));

var _pure = _interopRequireDefault(require("recompose/pure"));

var _analytics = require("../../common/analytics");

var _httpClient = _interopRequireDefault(require("../../common/httpClient"));

var _Input = _interopRequireDefault(require("angieslist-react-components/lib/Input"));

var _Row = _interopRequireDefault(require("angieslist-react-components/lib/Row"));

var _Col = _interopRequireDefault(require("angieslist-react-components/lib/Col"));

var _reactAutosuggest = _interopRequireDefault(require("react-autosuggest"));

var _match = _interopRequireDefault(require("autosuggest-highlight/match"));

var _parse = _interopRequireDefault(require("autosuggest-highlight/parse"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// react-autosuggest boilerplate - value used when user selects a suggestion
var getSuggestionValue = function getSuggestionValue(suggestion) {
  return suggestion.displayText;
}; // react-autosuggest boilerplate - array property for suggestions under each section


var getSectionSuggestions = function getSectionSuggestions(section) {
  return section.suggestions;
}; // render each suggestion, intelligently highlighting the text that matches
// the user input value


var renderSuggestion = function renderSuggestion(suggestion, _ref) {
  var query = _ref.query;
  var suggestionText = suggestion.displayText;
  var matches = (0, _match.default)(suggestionText, query);
  var parts = (0, _parse.default)(suggestionText, matches);
  return /*#__PURE__*/(0, _jsx2.default)("span", {}, void 0, parts.map(function (part, index) {
    return /*#__PURE__*/(0, _jsx2.default)("span", {
      className: part.highlight ? 'highlight' : null
    }, index, part.text);
  }));
};

var renderSectionTitle = function renderSectionTitle(section) {
  return (0, _get2.default)(section, 'suggestions.length') > 0 ? /*#__PURE__*/(0, _jsx2.default)("strong", {}, void 0, section.title) : '';
}; // Fetch suggestions but cache results in memory with _.memoize. The cache key
// is based on the queried URL and the component id (so that multiple components
// don't share results, in case the parsing function is different)


var fetchSuggestionsUrl = (0, _memoize2.default)( /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(url, parseSuggestionsResponse, id, maybeHttpClient) {
    var suggestionsResponse, suggestions;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!maybeHttpClient) {
              _context.next = 6;
              break;
            }

            _context.next = 3;
            return maybeHttpClient.fetch(url, {
              method: 'GET'
            });

          case 3:
            _context.t0 = _context.sent;
            _context.next = 9;
            break;

          case 6:
            _context.next = 8;
            return _httpClient.default.get(url);

          case 8:
            _context.t0 = _context.sent;

          case 9:
            suggestionsResponse = _context.t0;
            suggestions = parseSuggestionsResponse(suggestionsResponse);
            return _context.abrupt("return", suggestions);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2, _x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}(), function (url, parseSuggestionsResponse, id) {
  return "".concat(url).concat(id);
}); // This is 'class' because it is a container for react-autosuggest and manages
// react-autosuggest internal state

/* eslint react/prefer-stateless-function: 0 */

var Autocomplete = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Autocomplete, _React$Component);

  var _super = _createSuper(Autocomplete);

  function Autocomplete(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Autocomplete);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      value: '',
      suggestion: null,
      // not required by react-autosuggest but useful for Redux forms
      suggestions: []
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "submit", function () {
      var value = _this.input.value;

      if (!(0, _isEmpty2.default)(value)) {
        _this.props.onSubmit(value);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "submitSuggestion", function () {
      _this.props.onSubmit(_this.state.suggestion);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onIconClick", _this.submit);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSuggestionSelected", function (event, _ref3) {
      var suggestion = _ref3.suggestion,
          suggestionValue = _ref3.suggestionValue,
          sectionIndex = _ref3.sectionIndex,
          method = _ref3.method;

      if (_this.props.trackClick) {
        _this.props.trackClick(suggestion);
      }

      if (_this.props.multiSection && _this.props.handleSelectionBySection) {
        _this.props.handleSelectionBySection(sectionIndex, suggestion, _this.state.value);
      }

      _this.props.onSubmit(suggestion); // this.state.value is handled automatically but also keep track of the suggestion object


      _this.setState({
        suggestion: suggestion,
        value: _this.props.clearAfterSelection ? '' : _this.state.value
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderInputComponent", function (inputProps) {
      // make sure to honor events from parent redux form is one example
      var toPass = _objectSpread(_objectSpread({}, _this.props.otherProps), inputProps);

      return /*#__PURE__*/(0, _jsx2.default)(_analytics.Track, {}, void 0, /*#__PURE__*/_react.default.createElement(_Input.default, (0, _extends2.default)({}, toPass, {
        id: inputProps.id,
        ref: function ref(x) {
          _this.input = x;
        },
        type: "text",
        addonBefore: _this.props.iconLocation === 'before' ? /*#__PURE__*/(0, _jsx2.default)("i", {
          onClick: _this.onIconClick,
          style: {
            cursor: 'pointer'
          },
          className: "icon icon-search",
          id: "".concat(inputProps.id, "-button")
        }) : ''
      })));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loadSuggestions", function (value) {
      var url = _this.props.getSuggestionsUrl(value);

      fetchSuggestionsUrl(url, _this.props.parseSuggestionsResponse, _this.props.id, _this.props.nextHttpClient).then(function (suggestions) {
        _this.setState({
          suggestions: suggestions
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChange", function (event, _ref4) {
      var newValue = _ref4.newValue;

      _this.setState({
        suggestion: null,
        // just clear this to make sure we handle cases of the user
        // deleting the input value
        value: newValue
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSuggestionsClearRequested", function () {
      _this.setState({
        suggestions: []
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSuggestionsFetchRequested", (0, _debounce2.default)(function (_ref5) {
      var value = _ref5.value;

      _this.loadSuggestions(value);
    }, _this.props.wait));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onInputBlur", function (event, value) {
      // this.state.value is not up-to-date at this point necessarily if you are mouse clicking
      // so use highlightedSuggestion.
      if (_this.props.requireSelection && value.highlightedSuggestion) {
        // this handles the case where if you tab after typing a few letters
        // it will autocomplete for you
        _this.setState({
          suggestion: value.highlightedSuggestion,
          value: _this.props.clearAfterSelection ? '' : value.highlightedSuggestion.displayText
        });
      } // For Redux forms support we have to call otherProps.onBlur with the suggestion
      // here but we also make sure to set the suggestion in onSuggestionSelected
      // to handle cases when the user clicks Enter and there won't be a highlightedSuggestion


      var other = (0, _get2.default)(_this.props, 'otherProps.onBlur', function () {});
      other(value.highlightedSuggestion || _this.state.suggestion);
    });
    _this.onSuggestionSelected = _this.onSuggestionSelected.bind((0, _assertThisInitialized2.default)(_this));
    _this.submitSuggestion = _this.submitSuggestion.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  } // internal state required by react-autosuggest


  (0, _createClass2.default)(Autocomplete, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          value = _this$state.value,
          suggestions = _this$state.suggestions;
      var _this$props = this.props,
          id = _this$props.id,
          placeholder = _this$props.placeholder,
          autoFocus = _this$props.autoFocus,
          multiSection = _this$props.multiSection,
          requireSelection = _this$props.requireSelection,
          submitButton = _this$props.submitButton;
      var inputProps = {
        id: "".concat(id, "-input"),
        placeholder: placeholder,
        value: value,
        autoFocus: autoFocus,
        onChange: this.onChange,
        onKeyDown: this.onKeyDown,
        onBlur: this.onInputBlur
      };
      return /*#__PURE__*/(0, _jsx2.default)(_Row.default, {}, void 0, /*#__PURE__*/(0, _jsx2.default)(_Col.default, {
        xs: submitButton ? 9 : 12
      }, void 0, /*#__PURE__*/(0, _jsx2.default)(_reactAutosuggest.default, {
        id: id,
        multiSection: multiSection,
        suggestions: suggestions,
        onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
        onSuggestionsClearRequested: this.onSuggestionsClearRequested,
        getSuggestionValue: getSuggestionValue,
        renderInputComponent: this.renderInputComponent,
        renderSuggestion: renderSuggestion,
        renderSectionTitle: renderSectionTitle,
        getSectionSuggestions: getSectionSuggestions,
        onSuggestionSelected: this.onSuggestionSelected,
        focusInputOnSuggestionClick: false,
        highlightFirstSuggestion: requireSelection,
        inputProps: inputProps
      })), submitButton ? /*#__PURE__*/(0, _jsx2.default)(_Col.default, {
        xs: 3
      }, void 0, /*#__PURE__*/_react.default.cloneElement(submitButton, {
        onClick: this.submitSuggestion
      })) : null);
    }
  }]);
  return Autocomplete;
}(_react.default.Component);

Autocomplete.defaultProps = {
  placeholder: 'What are you looking for?',
  wait: 200,
  multiSection: false,
  iconLocation: 'before',
  requireSelection: false,
  clearAfterSelection: false,
  submitButton: undefined,
  otherProps: {}
};

var _default = (0, _compose.default)(_pure.default)(Autocomplete);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/browser/autocomplete/Autocomplete.js
// module id = 5018
// module chunks = 25